import React from "react";
import { IResourceComponentsProps, HttpError } from "@refinedev/core";
import { Create, useForm } from "@refinedev/mantine";
import { TextInput, NumberInput, Select, Switch } from "@mantine/core";
import { isNotEmpty } from "@mantine/form";
import { CancellationReason } from "entities/cancel_flow";
import { selectBrands } from "entities/cancel_flow/brand";

export const CancellationReasonCreate: React.FC<IResourceComponentsProps> = () => {
  const { getInputProps, saveButtonProps } = useForm<
    CancellationReason,
    HttpError,
    CancellationReason
  >({
    initialValues: {
      id: 0,
      brand: "tokyotreat" as CancellationReason["brand"],
      label: "",
      sort_order: 0,
      is_active: true,
      allow_custom_text: false,
      created_at: "",
      updated_at: "",
    },
    validateInputOnBlur: true,
    validate: {
      brand: isNotEmpty("Brand is required"),
      label: isNotEmpty("Label is required"),
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Select
        label="Brand"
        data={selectBrands}
        withAsterisk
        {...getInputProps("brand")}
      />
      <TextInput
        mt="sm"
        label="Label"
        withAsterisk
        {...getInputProps("label")}
      />
      <NumberInput
        mt="sm"
        label="Sort Order"
        {...getInputProps("sort_order")}
      />
      <Switch
        mt="sm"
        label="Active"
        {...getInputProps("is_active", { type: "checkbox" })}
      />
      <Switch
        mt="sm"
        label="Allow Custom Text"
        {...getInputProps("allow_custom_text", { type: "checkbox" })}
      />
    </Create>
  );
};
